import { useQuery } from '@tanstack/vue-query'
import { computed, toValue, type MaybeRefOrGetter } from 'vue'
import { getPropertyRentLedger } from '../rentLedgerEndpoints'
import { rentLedgerKeys } from '../rentLedgerQueryKeys'

export function usePropertyRentLedgerQuery(propertyId: MaybeRefOrGetter<string | null>) {
  const queryKey = computed(() => rentLedgerKeys.detail(toValue(propertyId) ?? ''))

  return useQuery({
    queryKey,
    queryFn: () => getPropertyRentLedger(toValue(propertyId) as string),
    enabled: () => Boolean(toValue(propertyId)),
  })
}
